import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import VueMoment from 'vue-moment';
import VueMask from 'v-mask';
import ToastPlugin from '@/plugins/toast';
import VueSimpleSVG from 'vue-simple-svg';
import VueApexCharts from 'vue-apexcharts';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { httpClient } from '@/utils/request/http';
import auth from '@/services/auth/auth';
import user, { hasPermission, getActiveCompanyId } from '@/services/auth/user';

import '@/assets/styles/tokens.css';
import '@/utils/global/index';

Vue.use(VueMoment);
Vue.use(VueMask);
Vue.use(VueSimpleSVG);
Vue.use(VueApexCharts);
Vue.component('ApexChart', VueApexCharts);
Vue.component('BaseIcon', BaseIcon);

Vue.use(ToastPlugin);

// Suprime o overlay de runtime error do dev server quando o erro de HTTP já
// foi tratado pelo interceptor (toast exibido). Erros não-marcados seguem o
// fluxo normal e continuam aparecendo no console pra debug.
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason._handled) {
    event.preventDefault();
  }
});

Vue.config.productionTip = false;

Vue.prototype.$http = httpClient;
Vue.prototype.$auth = auth;
Vue.prototype.$user = user;
// Helper de autorização: $can('users.create'), $can('companies.delete'), etc.
// Lê do user reactive — re-renderiza ao logar/deslogar automaticamente.
Vue.prototype.$can  = hasPermission;
// Filtro de CNPJ ativo do dropdown global (null = todos vinculados).
// Defino como getter pra retornar sempre o valor atual do user observable.
Object.defineProperty(Vue.prototype, '$activeCompanyId', {
  get() { return getActiveCompanyId(); },
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
